export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="section-container">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 mb-3">
            关于我们
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-6">
            吃瓜爆料网 — 你的全网吃瓜导航专家
          </h2>
          <div className="text-foreground-600 text-sm md:text-base leading-relaxed space-y-4">
            <p>
              吃瓜爆料网成立于2024年，是国内领先的吃瓜爆料网站聚合导航平台。我们致力于为用户提供全网最新、最全、最可靠的吃瓜爆料网站入口，涵盖娱乐圈、网红圈、综艺节目、社会热点等多个领域。
            </p>
            <p>
              平台采用人工审核机制，每一家收录的吃瓜爆料网站都经过严格筛选，确保内容质量和更新频率。我们每日跟踪各平台的运营状态，及时更新推荐排名，让你始终访问到最活跃、最值得关注的吃瓜爆料网站。
            </p>
            <p>
              无论你是资深吃瓜群众还是刚入圈的新手，吃瓜爆料网都能帮你快速找到心仪的平台，一站导航，省去到处搜索的麻烦。我们相信，好的工具让吃瓜更简单、更高效。
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6 mt-10">
            <div className="bg-background-100 rounded-xl p-6 border border-background-200/60">
              <div className="w-12 h-12 rounded-xl bg-primary-50 flex items-center justify-center mx-auto mb-3">
                <i className="ri-shield-check-line text-xl text-primary-600"></i>
              </div>
              <div className="text-lg font-heading font-bold text-foreground-950 mb-1">人工审核</div>
              <div className="text-xs text-foreground-500">每站严格把关</div>
            </div>
            <div className="bg-background-100 rounded-xl p-6 border border-background-200/60">
              <div className="w-12 h-12 rounded-xl bg-accent-50 flex items-center justify-center mx-auto mb-3">
                <i className="ri-refresh-line text-xl text-accent-600"></i>
              </div>
              <div className="text-lg font-heading font-bold text-foreground-950 mb-1">每日更新</div>
              <div className="text-xs text-foreground-500">榜单实时刷新</div>
            </div>
            <div className="bg-background-100 rounded-xl p-6 border border-background-200/60">
              <div className="w-12 h-12 rounded-xl bg-secondary-50 flex items-center justify-center mx-auto mb-3">
                <i className="ri-global-line text-xl text-secondary-600"></i>
              </div>
              <div className="text-lg font-heading font-bold text-foreground-950 mb-1">全面覆盖</div>
              <div className="text-xs text-foreground-500">200+平台收录</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}